import React, { useState } from 'react'
import { NavLink } from 'react-router-dom'
import styled from 'styled-components'

import AlertIconWithCount from 'pages/shared/Alert/IconWithCount'
import Card from 'components/Card'
import Pagination from 'components/Pagination'
import Pin from 'pages/shared/Pin'

import Apptentive from 'helpers/apptentive'
import { customerDisplayName } from 'helpers/formatters'
import GA4 from 'helpers/ga4'

import usePagedCustomers from 'hooks/usePagedCustomers'
import { useStoreContext } from 'hooks/StoreContext'

import { color } from 'styles/colors'
import { screenSize } from 'styles/shared'

const ASC_SORT = 'asc'

const PinnedCustomersPanel = () => {
  const [refreshTimestamp] = useState(Date.now())
  const [page, setPage] = useState(1)

  usePagedCustomers({
    query: '',
    filters: 'pinned',
    page,
    sortAttribute: 'customer',
    sortDirection: ASC_SORT,
    size: '10',
    refreshTimestamp
  })

  const { customersMetadata, arePagedCustomersLoaded } = useStoreContext()
  const { customers } = useStoreContext()

  const handlePageChange = (p) => {
    setPage(p)
  }

  return (
    <Card
      title="Pinned Customers"
      titleAreaRight={customersMetadata?.pageCount > 1
        ? <S.Pagination
            size="medium"
            pageCount={customersMetadata?.pageCount}
            onPageChange={handlePageChange}
            page={customersMetadata?.pageNumber}
          />
        : null
      }
      titleAreaStyle={`
        @media ${screenSize.small} {
          justify-content: unset;
          flex-direction: column;
        }
      `}
      isLoaded={arePagedCustomersLoaded}
    >

      {customers && customers.map(customer => {
        const displayName = customerDisplayName(
          customer.firstName,
          customer.lastName,
          customer.companyName
        )

        const sendEvent = () => {
          const gAEvent = {
            category: 'Dashboard Page',
            action: 'Click Pinned Customer Name',
            label: displayName
          }

          GA4.sendEvent(gAEvent)
          Apptentive.sendEvent('view_customer_from_pinned')
        }

        return (
          <S.PinnedCustomer key={`customer-id:${customer.id}`}>
            <S.LeftColumn>
              <S.Pin
                isPinned={customer.pinned}
                customerName={displayName}
                customerId={customer.id}
                pinnedAt={customer.pinnedAt}
                displayUnpinned
              />

              <NavLink to={`/customers/${customer.id}`} onClick={sendEvent}>
                {displayName}
              </NavLink>
            </S.LeftColumn>

            <AlertIconWithCount severity="critical" count={customer.criticalAlarmCount} />
            <AlertIconWithCount severity="major" count={customer.majorAlarmCount} />
            <AlertIconWithCount severity="major-sda" count={customer.sdaMajorAlarmCount} />
            <AlertIconWithCount severity="minor" count={customer.minorAlarmCount} />
            <AlertIconWithCount severity="minor-sda" count={customer.sdaMinorAlarmCount} />
          </S.PinnedCustomer>
        )
      })}
    </Card>
  )
}

export default PinnedCustomersPanel

const S = {
  Pagination: styled(Pagination)`
    float: unset;
    align-self: end;
  `,
  PinnedCustomer: styled.div`
    display: flex;
    padding: 8px 0;
    margin-top: 10px;
    border: 1px solid ${color('border')};
    border-radius: 6px;
  `,
  LeftColumn: styled.div`
    display: flex;
    flex: 1;
  `,
  Pin: styled(Pin)`
    position: relative;
    top: 3px;
    margin: 0 8px 0 8px;
  `
}
